class EmailStorage {
  private readonly STORAGE_KEY = 'remembered_email'
  private readonly REMEMBER_KEY = 'remember_email_preference'

  private async openDB(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('AuthStorage', 1)

      request.onerror = () => reject(request.error)
      request.onsuccess = () => resolve(request.result)

      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result
        if (!db.objectStoreNames.contains('emails')) {
          db.createObjectStore('emails')
        }
      }
    })
  }

  async saveEmail(email: string, remember: boolean): Promise<void> {
    try {
      const db = await this.openDB()
      const transaction = db.transaction(['emails'], 'readwrite')
      const store = transaction.objectStore('emails')

      if (remember) {
        await store.put(email, this.STORAGE_KEY)
        await store.put(true, this.REMEMBER_KEY)
      } else {
        await store.delete(this.STORAGE_KEY)
        await store.put(false, this.REMEMBER_KEY)
      }
    } catch (error) {
      console.warn('Erro ao salvar email:', error)
      if (remember) {
        document.cookie = `${this.STORAGE_KEY}=${email}; max-age=${365 * 24 * 60 * 60}; path=/`
        document.cookie = `${this.REMEMBER_KEY}=true; max-age=${365 * 24 * 60 * 60}; path=/`
      } else {
        document.cookie = `${this.STORAGE_KEY}=; max-age=0; path=/`
        document.cookie = `${this.REMEMBER_KEY}=false; max-age=${365 * 24 * 60 * 60}; path=/`
      }
    }
  }

  async getEmail(): Promise<{ email: string | null; remember: boolean }> {
    try {
      const db = await this.openDB()
      const transaction = db.transaction(['emails'], 'readonly')
      const store = transaction.objectStore('emails')

      const emailRequest = store.get(this.STORAGE_KEY)
      const rememberRequest = store.get(this.REMEMBER_KEY)

      const email = await new Promise<string | null>((resolve) => {
        emailRequest.onsuccess = () => resolve(emailRequest.result || null)
        emailRequest.onerror = () => resolve(null)
      })

      const remember = await new Promise<boolean>((resolve) => {
        rememberRequest.onsuccess = () => resolve(rememberRequest.result || false)
        rememberRequest.onerror = () => resolve(false)
      })

      return { email, remember }
    } catch (error) {
      console.warn('Erro ao recuperar email:', error)
      const emailCookie = this.getCookie(this.STORAGE_KEY)
      const rememberCookie = this.getCookie(this.REMEMBER_KEY) === 'true'

      return {
        email: emailCookie,
        remember: rememberCookie
      }
    }
  }

  private getCookie(name: string): string | null {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift() || null
    }
    return null
  }

  async clearEmail(): Promise<void> {
    await this.saveEmail('', false)
  }
}

export const emailStorage = new EmailStorage()